module.exports = __webpack_public_path__ + "assets/img/4b5bcf152f312eb5b669b596d3970efe.svg";